var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-button", {
        attrs: { "icon-pack": "fas", "icon-left": "question-circle" },
        on: {
          click: function($event) {
            _vm.open = !_vm.open
          }
        }
      }),
      _vm._v(" "),
      _c(
        "b-sidebar",
        {
          attrs: {
            type: "is-light",
            fullheight: true,
            fullwidth: false,
            overlay: false,
            right: true,
            open: _vm.open
          },
          on: {
            "update:open": function($event) {
              _vm.open = $event
            }
          }
        },
        [_vm._t("default")],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2fb36baa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fb36baa","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/help-sidebar/HelpSidebar.vue
// module id = null
// module chunks = 